export const url = {
  newConcept: '/auth/concept/newConcepts',
  hitConcept: '/auth/concept/top10HitConcepts',
  // list: '/auth/concept/index/list',
  detail: '/auth/concept/web/detail',
  topTrade: '/auth/concept/top10trade',
  topFormulation: '/auth/concept/top10formultion',
  tabList: '/auth/concept/tab/list/search',
  search: '/auth/concept/search',
  getLastUpdateTime: '/auth/concept/lastUpdateTime',
  getHighLight: '/auth/concept/top1'
}



// WEBPACK FOOTER //
// ./src/axios/api_urls/conceptCollections.js